import React, { useEffect } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { MyButton } from "../../../../common/components";
import CustomDialog from "../../../../common/components/CustomDialog";

import RegisterUserForm, {
  initialValues,
  registerUserValidationSchema,
} from "../../../../auth/RegisterUser/RegisterUserForm";

const CreateUserDialog = ({ open, onClose, fieldsUser, appendUser, firstname, lastname, providerIndex, cacheUserData }) => {
  const methods = useForm({
    defaultValues: { ...initialValues, role_id: 6, firstname, lastname },
    resolver: yupResolver(registerUserValidationSchema),
    mode: "onChange",
  });

  const { handleSubmit, control, formState: { errors }, setValue, trigger, reset } = methods;

  const onSubmit = async (data) => {
    if (!fieldsUser) {
      cacheUserData({
        ...data,
      });
    } else {
      if (appendUser) {
        appendUser({ 
          ...data,
          providerIndex
        });
      }
    }

    onClose();
  };

  useEffect(() => {
    if (open) {
      reset({ ...initialValues, role_id: 6, firstname, lastname });
    }
  }, [open, firstname, lastname, reset]);

  return (
    <CustomDialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle>Create User</DialogTitle>

      <FormProvider {...methods}>
        <form
          onSubmit={(e) => {
            e.stopPropagation();
            handleSubmit(onSubmit)(e);
          }}
        >
          <DialogContent dividers>
            <RegisterUserForm
              control={control}
              errors={errors}
              setValue={setValue}
              trigger={trigger}
              hideRole={true}
              disabledFields={["firstname", "lastname"]}
            />
          </DialogContent>

          <DialogActions>
            <MyButton
              variant="outlined"
              fullWidth={false}
              color="secondary"
              onClick={onClose}
            >
              Cancel
            </MyButton>

            <MyButton
              type="submit"
              variant="contained"
              fullWidth={false}
              color="primary"
            >
              Save
            </MyButton>
          </DialogActions>
        </form>
      </FormProvider>
    </CustomDialog>
  );
};

export default CreateUserDialog;
